import { ComponentPropsWithoutRef } from 'react';
import { FormErrorText } from '@/components/FormErrorText';
import './Select.css';

export type SelectOptions = { value: string | number; label: string }[];

interface SelectProps extends ComponentPropsWithoutRef<'select'> {
    prompt?: string;
    options: SelectOptions;
    value?: string;
    className?: string;
    onChange?: (event: React.ChangeEvent<HTMLSelectElement>) => void;
    error?: string;
}

/**
 * Renders a select input.
 *
 * @param prompt - The prompt text to show as the first disabled option.
 * @param options - The options to render.
 * @param value - The selected value.
 * @param onChange - The change handler.
 * @param error - The error message.
 */
export function Select({
    prompt,
    options,
    value,
    onChange,
    className,
    error,
    ...rest
}: SelectProps) {
    const classes = `text-md appearance-none rounded-lg border border-grey-600 py-[14px] pl-4 pr-14 ${className}`;

    return (
        <>
            <select
                {...rest}
                className={classes}
                onChange={onChange}
                value={value}
                style={{
                    background:
                        '#fff url(/images/icons/chevron-down.svg) no-repeat right 14px center',
                }}
            >
                {prompt && (
                    <option value="" disabled>
                        {prompt}
                    </option>
                )}
                {options.map(({ value, label }) => (
                    <option key={value} value={value}>
                        {label}
                    </option>
                ))}
            </select>
            {error && <FormErrorText message={error} />}
        </>
    );
}
